module.exports = __webpack_public_path__ + "img/user-bg.05de7b1.png";